import condition_question_assignment_state_mixin from "@/utils/mixins/compliance_mixins/condition_question_assignment_state_mixin";
import condition_question_assignment_actions_mixin from "@/utils/mixins/compliance_mixins/condition_question_assignment_actions_mixin";

export default {
  mixins: [condition_question_assignment_state_mixin, condition_question_assignment_actions_mixin],
};

